import type { ReactNode } from 'react'
import { Button, StateBlock } from '@w7/ui'
import { useSession } from '@/api/hooks/shared/useSession'
import { resolveBookManagementAccess } from './access'

export function BookManagementAccessGate({ children }: { children: ReactNode }) {
  const { data: session, isPending, isError, error, refetch } = useSession()

  if (isPending && !session) {
    return (
      <StateBlock icon="lock" title="Checking access">
        Confirming you can open this workspace.
      </StateBlock>
    )
  }

  if (isError && !session) {
    return (
      <StateBlock
        icon="lock"
        title="Could not load your agent"
        tone="error"
        actions={
          <Button variant="secondary" onClick={() => void refetch()}>
            Try again
          </Button>
        }
      >
        {error instanceof Error
          ? error.message
          : 'Hierarchy did not return your agentId. Check Agent-API mocks or live hierarchy.'}
      </StateBlock>
    )
  }

  if (!resolveBookManagementAccess(session)) {
    return (
      <StateBlock icon="lock" title="You do not have access to this workspace" tone="error">
        Book Management is for agents, ops, and the risk desk.
      </StateBlock>
    )
  }

  return children
}
